import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { IconComponent } from '../icons/icon/icon.component';

export interface NavTab {
    label?: string;
    icon?: string;
    dot?: boolean;
    chip?: string | number;
    active?: boolean;
    routerLink?: string | unknown[];
    href?: string;
    ariaLabel?: string;
    ariaControls?: string;
    ariaExpanded?: boolean;
    ariaHasPopup?: string;
    onClick?: () => void;
}

export type NavTabSize = 'default' | 'small';

@Component({
    selector: 'app-nav-tab',
    templateUrl: './nav-tab.component.html',
    styleUrl: './nav-tab.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgTemplateOutlet, RouterLink, IconComponent],
})
export class NavTabComponent {
    readonly tabs = input<NavTab[]>([]);
    readonly size = input<NavTabSize>('default');

    protected readonly iconSize = computed(() => (this.size() === 'small' ? 16 : 24));

    protected onClick(tab: NavTab): void {
        tab.onClick?.();
    }
}
